const y = "styles-module__typography___yYjoT", _ = {
  typography: y,
  "typography--lowercase": "styles-module__typography--lowercase___QUNVD",
  "typography--uppercase": "styles-module__typography--uppercase___SVURG",
  "typography--capitalize": "styles-module__typography--capitalize___Nobxb",
  "typography--text-align-left": "styles-module__typography--text-align-left___IEJ7i",
  "typography--text-align-right": "styles-module__typography--text-align-right___0iNP9",
  "typography--text-align-center": "styles-module__typography--text-align-center___UlKBQ",
  "typography--text-align-justify": "styles-module__typography--text-align-justify___kmcM3",
  "typography--size-n3": "styles-module__typography--size-n3___TnpTH",
  "typography--size-n2": "styles-module__typography--size-n2___kNc5B",
  "typography--size-n1": "styles-module__typography--size-n1___90-Zg",
  "typography--size-0": "styles-module__typography--size-0___hN3pI",
  "typography--size-1": "styles-module__typography--size-1___Ggo-K",
  "typography--size-2": "styles-module__typography--size-2___qFGVg",
  "typography--size-3": "styles-module__typography--size-3___AM-62",
  "typography--size-4": "styles-module__typography--size-4___3-DCu",
  "typography--size-5": "styles-module__typography--size-5___e4588",
  "typography--bold": "styles-module__typography--bold___ak-mu",
  "typography--semibold": "styles-module__typography--semibold___CWKpT",
  "typography--regular": "styles-module__typography--regular___olzBF",
  "typography--primary": "styles-module__typography--primary___Qhkoy",
  "typography--primary-blue": "styles-module__typography--primary-blue___BkCKF",
  "typography--primary-dark": "styles-module__typography--primary-dark___zq5cZ",
  "typography--primary-light": "styles-module__typography--primary-light___sm2K4",
  "typography--primary-brand": "styles-module__typography--primary-brand___SpbQz",
  "typography--secondary": "styles-module__typography--secondary___UHxOY",
  "typography--secondary-50": "styles-module__typography--secondary-50___bShdp",
  "typography--secondary-100": "styles-module__typography--secondary-100___jJBxI",
  "typography--secondary-200": "styles-module__typography--secondary-200___NNwaa",
  "typography--secondary-300": "styles-module__typography--secondary-300___XKhP1",
  "typography--secondary-400": "styles-module__typography--secondary-400___YQkP5",
  "typography--secondary-500": "styles-module__typography--secondary-500___M1k9z",
  "typography--secondary-600": "styles-module__typography--secondary-600___CbrHM",
  "typography--secondary-700": "styles-module__typography--secondary-700___LV7pV",
  "typography--secondary-800": "styles-module__typography--secondary-800___yx4wl",
  "typography--secondary-900": "styles-module__typography--secondary-900___971rH",
  "typography--tertiary": "styles-module__typography--tertiary___8dEqD",
  "typography--tertiary-50": "styles-module__typography--tertiary-50___kswJM",
  "typography--tertiary-100": "styles-module__typography--tertiary-100___YEKeJ",
  "typography--tertiary-200": "styles-module__typography--tertiary-200___iDhMR",
  "typography--tertiary-300": "styles-module__typography--tertiary-300___aDsFM",
  "typography--tertiary-400": "styles-module__typography--tertiary-400___nGZ50",
  "typography--tertiary-450": "styles-module__typography--tertiary-450___pcyNi",
  "typography--tertiary-500": "styles-module__typography--tertiary-500___RyMHM",
  "typography--tertiary-600": "styles-module__typography--tertiary-600___DXUM7",
  "typography--tertiary-700": "styles-module__typography--tertiary-700___ht-2e",
  "typography--tertiary-800": "styles-module__typography--tertiary-800___mGbKG",
  "typography--tertiary-900": "styles-module__typography--tertiary-900___8DQdY",
  "typography--quaternary": "styles-module__typography--quaternary___SnDV8",
  "typography--quaternary-50": "styles-module__typography--quaternary-50___-jHUV",
  "typography--quaternary-100": "styles-module__typography--quaternary-100___JJLmZ",
  "typography--quaternary-200": "styles-module__typography--quaternary-200___FSXXT",
  "typography--quaternary-300": "styles-module__typography--quaternary-300___Q0LXk",
  "typography--quaternary-400": "styles-module__typography--quaternary-400___i5xGv",
  "typography--quaternary-500": "styles-module__typography--quaternary-500___-vjEP",
  "typography--quaternary-600": "styles-module__typography--quaternary-600___K9aPS",
  "typography--quaternary-700": "styles-module__typography--quaternary-700___3erIs",
  "typography--quaternary-800": "styles-module__typography--quaternary-800___1-Sco",
  "typography--quaternary-900": "styles-module__typography--quaternary-900___IdQLN",
  "typography--info": "styles-module__typography--info___gi2sM",
  "typography--info-50": "styles-module__typography--info-50___vsbmi",
  "typography--info-100": "styles-module__typography--info-100___TrOBn",
  "typography--info-200": "styles-module__typography--info-200___tDc00",
  "typography--info-300": "styles-module__typography--info-300___868Ad",
  "typography--info-400": "styles-module__typography--info-400___DAPFV",
  "typography--info-500": "styles-module__typography--info-500___-TvEA",
  "typography--info-600": "styles-module__typography--info-600___uPiPK",
  "typography--info-700": "styles-module__typography--info-700___4YXu9",
  "typography--info-800": "styles-module__typography--info-800___k0KwM",
  "typography--info-900": "styles-module__typography--info-900___0e2Tz",
  "typography--success": "styles-module__typography--success___81wNT",
  "typography--success-50": "styles-module__typography--success-50___po4WC",
  "typography--success-100": "styles-module__typography--success-100___4Khq5",
  "typography--success-200": "styles-module__typography--success-200___I4Cem",
  "typography--success-300": "styles-module__typography--success-300___d4Gyh",
  "typography--success-400": "styles-module__typography--success-400___mtl1M",
  "typography--success-500": "styles-module__typography--success-500___N0YPC",
  "typography--success-600": "styles-module__typography--success-600___zNEpn",
  "typography--success-700": "styles-module__typography--success-700___49K8l",
  "typography--success-800": "styles-module__typography--success-800___Gjo2J",
  "typography--success-900": "styles-module__typography--success-900___5Da4Z",
  "typography--alert": "styles-module__typography--alert___QIUsC",
  "typography--alert-50": "styles-module__typography--alert-50___7kMnF",
  "typography--alert-100": "styles-module__typography--alert-100___1SZq-",
  "typography--alert-200": "styles-module__typography--alert-200___zDwZq",
  "typography--alert-300": "styles-module__typography--alert-300___NzS0v",
  "typography--alert-400": "styles-module__typography--alert-400___M1hXX",
  "typography--alert-500": "styles-module__typography--alert-500___LeEXK",
  "typography--alert-600": "styles-module__typography--alert-600___473GD",
  "typography--alert-700": "styles-module__typography--alert-700___IxpY8",
  "typography--alert-800": "styles-module__typography--alert-800___kMU7w",
  "typography--alert-900": "styles-module__typography--alert-900___GVFtB",
  "typography--error": "styles-module__typography--error___IhsFK",
  "typography--error-50": "styles-module__typography--error-50___ucIL-",
  "typography--error-100": "styles-module__typography--error-100___-SfTQ",
  "typography--error-200": "styles-module__typography--error-200___EWxpt",
  "typography--error-300": "styles-module__typography--error-300___pW5A-",
  "typography--error-400": "styles-module__typography--error-400___54LxK",
  "typography--error-500": "styles-module__typography--error-500___XuaUN",
  "typography--error-600": "styles-module__typography--error-600___zigbL",
  "typography--error-700": "styles-module__typography--error-700___I2QFa",
  "typography--error-800": "styles-module__typography--error-800___u1hQH",
  "typography--error-900": "styles-module__typography--error-900___Bz2Ey",
  "typography--neutral": "styles-module__typography--neutral___SM-Nw",
  "typography--neutral-50": "styles-module__typography--neutral-50___K7b7U",
  "typography--neutral-100": "styles-module__typography--neutral-100___5aI65",
  "typography--neutral-150": "styles-module__typography--neutral-150___xOOhP",
  "typography--neutral-200": "styles-module__typography--neutral-200___3u1Th",
  "typography--neutral-300": "styles-module__typography--neutral-300___gMWn-",
  "typography--neutral-400": "styles-module__typography--neutral-400___8oVeY",
  "typography--neutral-500": "styles-module__typography--neutral-500___XOR1t",
  "typography--neutral-600": "styles-module__typography--neutral-600___niM28",
  "typography--neutral-700": "styles-module__typography--neutral-700___2Izkq",
  "typography--neutral-800": "styles-module__typography--neutral-800___bFWzK",
  "typography--neutral-900": "styles-module__typography--neutral-900___otHyx",
  "typography--grey": "styles-module__typography--grey___8rrf-",
  "typography--grey-50": "styles-module__typography--grey-50___I42qj",
  "typography--grey-100": "styles-module__typography--grey-100___jU8yh",
  "typography--grey-200": "styles-module__typography--grey-200___173Yl",
  "typography--grey-300": "styles-module__typography--grey-300___bEl3W",
  "typography--grey-400": "styles-module__typography--grey-400___9HYfF",
  "typography--grey-500": "styles-module__typography--grey-500___QrCQy",
  "typography--grey-600": "styles-module__typography--grey-600___IosuC",
  "typography--grey-700": "styles-module__typography--grey-700___8h-pO",
  "typography--grey-800": "styles-module__typography--grey-800___hFkF5",
  "typography--grey-900": "styles-module__typography--grey-900___CE28B",
  "typography--background": "styles-module__typography--background___zOks8",
  "typography--background-200": "styles-module__typography--background-200___bKfNU",
  "typography--background-full-white": "styles-module__typography--background-full-white___cxFHP",
  "typography--background-grey-50": "styles-module__typography--background-grey-50___IpP1T",
  "typography--background-neutral-50": "styles-module__typography--background-neutral-50___74dy5",
  "typography--background-grey-100": "styles-module__typography--background-grey-100___Ht3cq",
  "typography--background-tertiary": "styles-module__typography--background-tertiary___dfrvx",
  "typography--background-error": "styles-module__typography--background-error___QzSYk",
  "typography--background-tertiary-600": "styles-module__typography--background-tertiary-600___x5bRj",
  "typography--background-error-600": "styles-module__typography--background-error-600___R-nuF",
  "typography--background-neutral-900": "styles-module__typography--background-neutral-900___NJXzm",
  "typography--background-neutral-legacy": "styles-module__typography--background-neutral-legacy___UUyzX",
  "typography--background-win": "styles-module__typography--background-win___G3Gd3",
  "typography--typography": "styles-module__typography--typography___rfNOJ",
  "typography--typography-white": "styles-module__typography--typography-white___Ze4GG",
  "typography--typography-default": "styles-module__typography--typography-default___eHp0s",
  "typography--typography-link": "styles-module__typography--typography-link___jt1wh",
  "typography--typography-error": "styles-module__typography--typography-error___86Vzv",
  "typography--typography-sucess": "styles-module__typography--typography-sucess___t5YHS",
  "typography--typography-disabled": "styles-module__typography--typography-disabled___xxjMF",
  "typography--typography-marketing": "styles-module__typography--typography-marketing___8gwxz",
  "typography--typography-secondary": "styles-module__typography--typography-secondary___cajK1",
  "typography--icons-white": "styles-module__typography--icons-white___DZLsJ",
  "typography--icons-dark-grey": "styles-module__typography--icons-dark-grey___AIExV",
  "typography--icons-blue": "styles-module__typography--icons-blue___JwbTT",
  "typography--icons-red": "styles-module__typography--icons-red___qwNfy",
  "typography--icons-success": "styles-module__typography--icons-success___A0eG5",
  "typography--icons-warning": "styles-module__typography--icons-warning___FCqMj",
  "typography--icons-info": "styles-module__typography--icons-info___Q-MiM",
  "typography--icons-win": "styles-module__typography--icons-win___FBqWD",
  "typography--accent": "styles-module__typography--accent___jELO9",
  "typography--accent-orange": "styles-module__typography--accent-orange___aPkTI",
  "typography--accent-light": "styles-module__typography--accent-light___f-5me",
  "typography--ellipsis": "styles-module__typography--ellipsis___-2zcv"
};
export {
  _ as default,
  y as typography
};
